export interface InsuranceVariant {
  name: InsuranceVariantType;
  amount: number | null;
  isHightlighted: boolean;
}

export enum InsuranceVariantType {
  Minimal = "Minimal",
  Standard = "Standard",
  Comfort = "Comfort",

  Basic = "Basic",
  Me = "Me",
  Family = "Family",
}
